import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { RestrictionsMap } from './typings'
import { Restrictions } from 'typings/promotion'
import { messages } from './messages'

export function validationSuite(intl: IntlShape) {
  return create(
    ({
      maxUsage,
      maxUsagePerClient,
      maxItemsPerCart,
      maxItemsPerAttribute,
    }: Pick<Restrictions, RestrictionsMap>) => {
      const { $t } = intl

      omitWhen(maxUsage === undefined, () => {
        test(
          RestrictionsMap.MAX_USAGE,
          $t(messages.validation.greaterThan, { value: 0 }),
          () => {
            enforce(maxUsage).isNumeric().gt(0)
          }
        )
      })

      omitWhen(maxUsagePerClient === undefined, () => {
        test(
          RestrictionsMap.MAX_USAGE_PER_CLIENT,
          $t(messages.validation.greaterThan, { value: 0 }),
          () => {
            enforce(maxUsagePerClient).isNumeric().gt(0)
          }
        )
      })

      omitWhen(maxItemsPerCart === undefined, () => {
        test(
          `${RestrictionsMap.MAX_ITEMS_PER_CART}.value`,
          $t(messages.validation.greaterThan, { value: 0 }),
          () => {
            enforce(maxItemsPerCart?.value).isNumeric().gt(0)
          }
        )
      })

      omitWhen(maxItemsPerAttribute === undefined, () => {
        test(
          `${RestrictionsMap.MAX_ITEMS_PER_ATTRIBUTE}.value`,
          $t(messages.validation.greaterThan, { value: 0 }),
          () => {
            enforce(maxItemsPerAttribute?.value).isNumeric().gt(0)
          }
        )
      })
    }
  )
}
